export const eventImagePresets = [
  {
    label: "Gala",
    value: "/images/events/gala-banner.png",
    keys: ["gala"],
    keywords: ["gala"],
  },
  {
    label: "End of Summer Celebration",
    value: "/images/events/end-of-summer-banner.png",
    keys: ["end-of-summer"],
    keywords: ["end of summer", "summer"],
  },
  {
    label: "Golf Outing",
    value: "/images/events/golf-outing-banner.png",
    keys: ["golf-outing"],
    keywords: ["golf", "outing"],
  },
  {
    label: "General Event",
    value: "/images/events/general-event-banner.png",
    keys: [],
    keywords: [],
  },
];

export const generalEventImage = "/images/events/general-event-banner.png";

export const getPresetByImageUrl = (imageUrl) =>
  eventImagePresets.find((preset) => preset.value === imageUrl);

export const getEventFallbackImage = (event = {}) => {
  const key = (event.key || "").toLowerCase();
  const name = (event.name || "").toLowerCase();

  const preset = eventImagePresets.find(
    (option) =>
      option.keys.includes(key) ||
      option.keywords.some((keyword) => name.includes(keyword))
  );

  return preset ? preset.value : generalEventImage;
};

export const getEventImageUrl = (event = {}) =>
  event.imageUrl || getEventFallbackImage(event);
